import { render, staticRenderFns } from "./selectSortOptions.vue?vue&type=template&id=6f6d3a34&scoped=true"
import script from "./selectSortOptions.vue?vue&type=script&lang=js"
export * from "./selectSortOptions.vue?vue&type=script&lang=js"
import style0 from "./selectSortOptions.vue?vue&type=style&index=0&id=6f6d3a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d3a34",
  null
  
)

export default component.exports